import * as ReactRuntime from 'react';
import * as RouterRuntime from 'react-router-dom';
// @sentry/react is loaded dynamically to keep it out of the initial JS bundle.
// The static import was removed because App.js imports this file synchronously,
// which was pulling all Sentry sub-packages (~127 KiB) into the initial chunk.

let cachedSentrySdk = null;
let sentryInitialized = false;

function parseSampleRate(rawValue, fallback = 0.1) {
  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) return fallback;
  if (parsed < 0) return 0;
  if (parsed > 1) return 1;
  return parsed;
}

export async function initializeSentryMonitoring() {
  if (sentryInitialized) return;

  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  try {
    cachedSentrySdk = await import('@sentry/react');
  } catch {
    // eslint-disable-next-line no-console
    console.warn('[Sentry] @sentry/react could not be loaded.');
    return;
  }

  const Sentry = cachedSentrySdk;
  const React = ReactRuntime;
  const router = RouterRuntime;
  if (!React || !router) return;

  const tracesSampleRate = parseSampleRate(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE, 0.1);
  const integrations = [];

  if (typeof Sentry.reactRouterV6BrowserTracingIntegration === 'function') {
    integrations.push(Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation: router.useLocation,
      useNavigationType: router.useNavigationType,
      createRoutesFromChildren: router.createRoutesFromChildren,
      matchRoutes: router.matchRoutes,
    }));
  } else if (typeof Sentry.browserTracingIntegration === 'function') {
    integrations.push(Sentry.browserTracingIntegration());
  }

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations,
    tracesSampleRate,
    tracePropagationTargets: ['localhost', /^https:\/\/www\.trucksparkinghub\.com/],
  });

  sentryInitialized = true;
}

export function getSentryRoutesComponent(RoutesComponent) {
  // Sentry is loaded asynchronously after idle — it is not available at the time
  // App.js evaluates this call, so return the Routes component unmodified.
  // Error capturing and performance tracing still work via initializeSentryMonitoring().
  return RoutesComponent;
}
